import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const CountdownTimer = () => {
  const { t, isBangla, hasSelectedLanguage } = useLanguage();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const weddingDate = new Date('2026-08-16T15:00:00').getTime();
    
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const difference = weddingDate - now;
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000)
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);

  if (!hasSelectedLanguage) return null;

  const TimeBlock = ({ value, label }) => (
    <div className="text-center">
      <div 
        className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-white/80 backdrop-blur-sm border border-[#E6C288] rounded-xl sm:rounded-2xl flex items-center justify-center shadow-lg transition-transform duration-300 hover:scale-105"
      >
        <span className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold text-[#800020]">
          {String(value).padStart(2, '0')}
        </span>
      </div>
      <p className={`mt-2 text-xs sm:text-sm text-[#2D2424]/60 font-medium ${isBangla ? 'font-bangla' : ''}`}>
        {label}
      </p>
    </div>
  );

  return (
    <section 
      className="py-12 sm:py-16 md:py-20 px-4 bg-gradient-to-b from-[#F5E6D3] to-[#FFF8F0]"
      data-testid="countdown-section"
    >
      <div className="max-w-3xl mx-auto">
        {/* Section Title */}
        <h3 className={`text-center font-heading text-xl sm:text-2xl text-[#800020]/80 mb-6 sm:mb-8 ${isBangla ? 'font-bangla' : ''}`}>
          {t('countdownUntil')}
        </h3>

        {/* Countdown Grid */}
        <div className="flex justify-center gap-3 sm:gap-4 md:gap-6" data-testid="countdown-timer">
          <TimeBlock value={timeLeft.days} label={t('countdownDays')} />
          <TimeBlock value={timeLeft.hours} label={t('countdownHours')} />
          <TimeBlock value={timeLeft.minutes} label={t('countdownMinutes')} />
          <TimeBlock value={timeLeft.seconds} label={t('countdownSeconds')} />
        </div>

        {/* Decorative line */}
        <div className="w-24 sm:w-32 mx-auto h-0.5 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent mt-8 sm:mt-10" />
      </div>
    </section>
  );
};

export default CountdownTimer;
